import { isDemo, isProduction } from 'constants/env';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';

const GA4_ID = 'G-2VGCQ47C1J';
const GTM_ID = 'GTM-5HM3SD9';

export const GoogleAnalytics = () => {
  useEffect(() => {
    if (isProduction && !isDemo) {
      ReactGA.initialize(GA4_ID);
      // @eslint-disable-next-line
      TagManager.initialize({
        gtmId: GTM_ID,
      });
    }
  }, []);

  return null;
};
